import { PlaceType } from "inbounds/createShipment/CreateShipmentTypes";
import isEmpty from "lodash/isEmpty";

// check if place is an address, not a port grouping
export const getIsPlaceAddress = (place: PlaceType): boolean =>
  !isEmpty(place.value.address.city) && place.value.ports.length === 0;
